import { useEffect, useState } from "react";

/**
 * Hides the sticky mobile CTA bar when the page footer enters the viewport,
 * so it does not overlap footer content while scrolling the details page.
 */
export function useHideMobileCtaNearFooter() {
  const [hideCTAMobile, setHideCTAMobile] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.getElementById("footer-container");
      const footerPosition = footer?.getBoundingClientRect();

      if (!footerPosition) {
        return;
      }

      const shouldHide = footerPosition.top - window.innerHeight < 0;
      setHideCTAMobile((prev) => (prev === shouldHide ? prev : shouldHide));
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return hideCTAMobile;
}
